import React from "react";
import get from "lodash/get";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import { useFormikContext } from "formik";
import { notNothing } from "utils/data";
import { getToggleCheckoutAttributesValues } from "utils/checkout/attributes";

const CheckoutAttributeToggle = ({ attributes, disabled, onChange }) => {
  const { setValues, setTouched, values, touched } = useFormikContext();

  let ctxActive = false;
  let ctxTouched = false;
  for (let index = 0; index < attributes.length; index++) {
    const { path } = attributes[index];

    if (!ctxActive) {
      ctxActive = notNothing(get(values, path));
    }
    if (!ctxTouched) {
      ctxTouched = notNothing(get(touched, path));
    }

    if (ctxActive && ctxTouched) {
      break;
    }
  }

  const ctxDisabled = Boolean(!ctxActive && disabled);

  return (
    <Toggle
      {...getToggleProps({
        disabled: ctxDisabled,
        active: ctxActive,
        setFieldValue: (_, active) => {
          const {
            touched: updatedTouched,
            values: updatedValues
          } = getToggleCheckoutAttributesValues({
            touched,
            attributes,
            values,
            isTouched: ctxTouched,
            active
          });
          updatedTouched && setTouched(updatedTouched);
          updatedValues && setValues(updatedValues);

          onChange(active);
        }
      })}
    />
  );
};

export default CheckoutAttributeToggle;
